"use strict";
const includes = require('lodash/includes');
const { env, isDevelopment, applicationUrls } = require('../auth/consts');
const fullUrlSuffix = isDevelopment ? '/debug.html' : '/';
const getCurrent = (origin) => {
    if (origin && includes(origin, 'app-eu1')) {
        return 'https://app-eu1.totango.com';
    }
    return applicationUrls[env];
};
const getFullUrl = (origin, isFromAddin) => `${getCurrent(origin)}${isFromAddin ? '' : fullUrlSuffix}`;
module.exports = {
    getCurrent,
    getFullUrl,
};
//# sourceMappingURL=index.js.map